import { graphql, useStaticQuery } from "gatsby";

export const PaymentProviders = () => {
  const { allPaymentMethods } = useStaticQuery(graphql`
    query AllPaymentMethods {
      allPaymentMethods {
        edges {
          node {
            body {
              childrenImageBlock {
                image {
                  alt
                  image {
                    fluid {
                      src
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);
  return allPaymentMethods.edges.map(({ node }: any) => node);
};
